import { useEffect, useState } from 'react';
import NavBar from '../../components/Navigation/NavBar';
import Footer from '../../components/Footer/Footer';
import SGLoopMainGroups from '../../components/SGLoop/MainGroups';
import SGLoopSubGroups from '../../components/SGLoop/SubGroups';
import { getAllGroupsOrdered } from '../../services/firestore/SGloopService';

export default function SGLoopHomePage() {
  const [selected, setSelected] = useState(null);
  const [selectedSubGroup, setSelectedSubGroup] = useState(null);
  const [allSGloopGroup, setAllSGloopGroup] = useState([]);

  const handleBack = () => setSelected(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await getAllGroupsOrdered();
        setAllSGloopGroup(response);

        const params = new URLSearchParams(window.location.search);
        const idFromUrl = params.get("id");

        if (idFromUrl) {
          const group = response.find((item) => item.id === idFromUrl);
          if (group) setSelected(group);
        } else if (window.innerWidth >= 768 && response.length > 0) {
          // Default selection on desktop
          setSelected(response[0]);
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    fetchGroups();
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      const params = new URLSearchParams(window.location.search);
      const idFromUrl = params.get("id");

      if (idFromUrl) {
        const group = allSGloopGroup.find((item) => item.id === idFromUrl);
        setSelected(group || null);
      } else {
        setSelected(null);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [allSGloopGroup]);

  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      {/* Main Content Area */}
      <div className="flex-grow mt-20 flex flex-col md:flex-row overflow-hidden">
        {/* Left Column (List) */}
        <SGLoopMainGroups
          dataList={allSGloopGroup}
          selected={selected}
          setSelected={setSelected}
          setSelectedSubGroup={setSelectedSubGroup}
        />

        {/* Right Column (Detail) */}
        <SGLoopSubGroups
          selected={selected}
          handleBack={handleBack}
          selectedSubGroup={selectedSubGroup}
          setSelectedSubGroup={setSelectedSubGroup}
        />
      </div>
      <Footer />
    </div>
  );
}
